<template>
  <div class='regist_body'>
    <div class='header'>
      <h1 class='title'>注册新用户</h1>
      <router-link class='backToLogin' to='/navigator/auth/login'>已有账号，去登录</router-link>
    </div>
    <div class='body'>
      <p class='tip'>
        <img class='logo' src='./images/u223.png'/>
        <span class='title'>恭喜，成功注册天安智慧云！</span>
      </p>
      <p class='options'>
        <el-button class='self' size='mini' @click='back("/navigator/auth/login")'>返回登录</el-button>
        <el-button class='index' size='mini' @click='back("/navigator")'>首页</el-button>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  methods: {
    back(path) {
      this.$router.push({ path: path, });
    },
  },
  computed: {
  },
};
</script>

<style lang='scss' scoped>
.regist_body{
  max-width: 1200px;
  margin: 60px auto;
  background: #ffffff;
  .header{
    padding: 0 40px;
    height: 68px;
    line-height: 68px;
    border-bottom: 1px solid #c4c4c4;
    .title{
      float: left;
    }
    .backToLogin{
      float: right;
      color: #666666;
    }
    .backToLogin:hover{
      text-decoration: underline;
    }
  }
  .body{
    text-align: center;
    padding: 60px 0;
    .tip{
      .logo, .title{
        display: inline-block;
        vertical-align: middle;
      }
      .title{
        margin-left: 12px;
        font-size: 18px;
        font-weight: 600;
      }
    }
    .options{
      margin-top: 40px;
      .self{
        background: #FF4500;
        border-color: #FF4500;
        color: #ffffff;
      }
      .self:hover{
        background: #ffffff;
        border-color: #FF4500;
        color: #FF4500;
      }
      .index{
        border-color: #FF4500;
        color: #FF4500;
      }
      .index:hover{
        background: #FF4500;
        border-color: #FF4500;
        color: #ffffff;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/auth/RegistSuccess.vue